import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs';
import { first } from 'rxjs/operators';
import {
  RoutesCons, StringConst,
  TabsNames,
  TypeScreenView
} from '../constants/const';
import {
  GeneralMessage,
  NotificationAuthorizeOrder
} from '../model/device/message.model';
import {
  DeleteInputSelect,
  ICatalogsMissingPro,
  ItemInformation,
  ItemProductSegmentation,
  ValidateParamsSearchForGroup
} from '../model/http/catalogs';
import {
  CheckShoppingAndAdviser,
  ClientDoctorModel,
  RouteView
} from '../model/http/clientDoctorModel';
import { ContainerSelectorEstructor } from '../model/http/container-selector.model';
import {
  IOrders
} from '../model/http/historyOrders.model';
import {
  CallPlace,
  InfoFavourites,
  InvoiceTab,
  IProducts, ReloadData
} from '../model/http/myActivity.model';
import { BackOrderActionsButtons } from '../model/http/pendingOrders';
import {
  DeliveredDirections,
  DirectionsAndTaxs,
  IMyProfile,
  PaymentCard,
  RecipeSettingsObj,
  TaxData
} from '../model/http/profile.model';
import {
  CartCount,
  MissingItems
} from '../model/http/shoppingList';
import { CatalogFilterDefinition } from '../model/local/catalogs.model';
import { DirectionsType } from '../model/local/directions.type';
import {
  FileSelectedResult, ReturnToTab, SelectedDateRange, SignatureData,
  TabsOrders,
  TabsProfile
} from '../model/local/general.model';
import { ListTypeProduct } from '../model/local/list.type.product.model';
import { MenuItem } from '../model/local/menu-items.model';
import { SearchProduct } from '../model/local/search.product.model';
import { ChangeShoppingTab, ReloadShoppingCar } from '../model/local/shopping-cart';
import { SpinnerConfig } from '../model/local/spinner';
import { UpdateShoppingCartModel } from '../model/local/updateShoppingCartModel';

@Injectable({
  providedIn: 'root',
})
export class ObservableService {
  private isLoading = new Subject<SpinnerConfig>();
  private dismissView = new Subject<void>();
  private totalProducts = new Subject<void>();
  private catalogsMissingProduct = new BehaviorSubject<ICatalogsMissingPro>({
    value: StringConst.empty,
  });
  private resultNotificationGeneric = new Subject<GeneralMessage>();
  private deleteProduct = new Subject<IProducts>();
  private deleteProductById = new Subject<number>();
  private whoRequest = new Subject<CallPlace>();
  private infoFavourites = new Subject<InfoFavourites>();
  private whoRequestForMenu = new Subject<MenuItem>();
  private isCardCodeOk = new ReplaySubject<boolean>();
  private isInfoLoading = new BehaviorSubject<void>(undefined);
  private dataDirectionUpdate = new Subject<DeliveredDirections>();
  private dataDirectionDeliveryPayment = new Subject<DeliveredDirections>();
  private taxData = new Subject<TaxData>();
  private taxDataDeliveryPayment = new Subject<TaxData>();
  private signatureResult = new Subject<SignatureData>();
  public isWebMessage = false;
  public isResizeSignatureConst = false;
  private realoadData = new BehaviorSubject<ReloadData>({ index: 0, callPlace: CallPlace.default });
  private myProfileViewWasScrolled = new Subject<TabsProfile>();
  private defaultAddress = new Subject<DirectionsAndTaxs>();
  private changeFavoriteEdit = new Subject<boolean>();
  private autoSelectFirstTab = new Subject<boolean>();
  private couterPiecesShoppingCard = new Subject<void>();
  private updateMenuPhoto = new Subject<FileSelectedResult>();
  private profileTabSelected = new BehaviorSubject<TabsProfile>(
    TabsProfile.default
  );
  private tabToReturn = new BehaviorSubject<ReturnToTab>({tab: 0, isFromReturn: false, bottomsheet: TabsNames.profile});
  private paymentCardAction = new Subject<boolean>();
  private dataPaymentUpdate = new Subject<PaymentCard>();
  private downloadPrescription = new Subject<IOrders>();
  private typeScreenViewObs = new Subject<TypeScreenView>();
  public typeScreenView = TypeScreenView.default;
  private paymentMethodsList = new ReplaySubject<PaymentCard[]>();
  private recipeSettingAction = new Subject<RecipeSettingsObj>();
  private title = new Subject<string>();
  private typeProduct = new Subject<ListTypeProduct>();
  private updateOnlyProfilePhoto = new Subject<FileSelectedResult>();
  private updateOnlyMenuProfilePhoto = new Subject<FileSelectedResult>();
  private notificationToComponents = new Subject<boolean>();
  private activeContainerSelector = new Subject<ContainerSelectorEstructor>();
  private updateAdviserInfo = new Subject<void>();
  private infoClientAdviser = new Subject<ClientDoctorModel>();
  private routeInfoDoctor = new Subject<string>();
  private infoViewClientAdviser = new BehaviorSubject<CheckShoppingAndAdviser>(
    new CheckShoppingAndAdviser()
  );
  private updateShoppingCart = new Subject<UpdateShoppingCartModel>();
  private resetformSelectMultiple = new Subject<DeleteInputSelect>();
  private resetFilterSelectMultiple = new Subject<DeleteInputSelect>();
  private resetFilterInputSelect = new Subject<DeleteInputSelect>();
  private resetformInput = new Subject<DeleteInputSelect>();
  private getHeaderProfile = new Subject<IMyProfile>();
  private realodCatalogs = new Subject<string>();
  private orderTabSelected = new BehaviorSubject<TabsOrders>(
    TabsOrders.default
  );
  private selectedItemCatalog = new Subject<ItemInformation>();
  private searchProductByCatalog = new Subject<SearchProduct>();
  private showAdvisorsMobile = new Subject<boolean>();
  private isResetBioquealClusters = new Subject<boolean>();
  private validateIfIsActive = new Subject<ValidateParamsSearchForGroup>();
  private infoAdvisorIsOk = new ReplaySubject<boolean>();
  private invoiceTab = new BehaviorSubject<InvoiceTab>(InvoiceTab.default);
  private itemsToDelete = new Subject<MissingItems[]>();
  private scrollAverageTicket = new Subject<void>();
  private search = new Subject<void>();
  private filtersChange = new BehaviorSubject<CatalogFilterDefinition>(new CatalogFilterDefinition());
  private generateFilters = new Subject<CatalogFilterDefinition>();
  private reloadSelectedFilters = new Subject<void>();
  private reloadCounter = new Subject<void>();
  private reloadProduct = new Subject<void>();
  private productsQuantity = new Subject<CartCount[]>();
  private reloadShoppingCar = new Subject<ReloadShoppingCar>();
  private changeShoppingTab = new Subject<ChangeShoppingTab>();
  private clearSAPFilters = new Subject<void>();
  private selectedPageFilter = new Subject<SelectedDateRange>();
  private reloadDirectionByType = new BehaviorSubject<DirectionsType>(DirectionsType.default);
  private imageLoaded = new Subject<string>();
  private couponCode = new Subject<string>();
  private validatefavorBalance = new Subject<void>();
  private stopFlow = new Subject<void>();
  private resetFiltersSub = new Subject<void>();
  private generalSearch = new Subject<string>();
  private addressAliasFilter = new Subject<string>();
  pendingPromotions = 0;

  constructor() { }
  setReloadProductCard(): void {
    this.reloadProduct.next();
  }
  getReloadProductCard(): Observable<void> {
    return this.reloadProduct.asObservable();
  }
  setSearch(): void {
    this.search.next();
  }
  setFiltersChange(data: CatalogFilterDefinition): void {
    this.filtersChange.next(data);
  }
  getFiltersChange(): Observable<CatalogFilterDefinition> {
    return this.filtersChange.asObservable();
  }

  resetFilters(): void {
    this.filtersChange = new BehaviorSubject<CatalogFilterDefinition>(new CatalogFilterDefinition());
  }
  resetProfileTab(): void {
    this.tabToReturn = new BehaviorSubject<ReturnToTab>(new ReturnToTab());
  }
  setGenerateAgainFilters(data: CatalogFilterDefinition): void {
    this.generateFilters.next(data);
  }
  getGenerateAgainFilters(): Observable<CatalogFilterDefinition> {
    return this.generateFilters.asObservable();
  }
  setReloadFiltersSelected(): void {
    this.reloadSelectedFilters.next();
  }
  getReloadFiltersSelected(): Observable<void> {
    return this.reloadSelectedFilters.asObservable();
  }
  getSearch(): Observable<void> {
    return this.search.asObservable();
  }
  setSearchProductByCatalog(data: SearchProduct): void {
    this.searchProductByCatalog.next(data);
  }

  getSearchProductByCatalog(): Observable<SearchProduct> {
    return this.searchProductByCatalog.asObservable();
  }

  getHeaderProfileDoctor(): Observable<IMyProfile> {
    return this.getHeaderProfile.asObservable();
  }
  setHeaderProfileDoctor(info: IMyProfile): void {
    this.getHeaderProfile.next(info);
  }
  getReloadCatalogs(): Observable<string> {
    return this.realodCatalogs.asObservable();
  }

  setReloadCatalogs(type: string): void {
    this.realodCatalogs.next(type);
  }
  getResetformSelectMultiple(): Observable<DeleteInputSelect> {
    return this.resetformSelectMultiple.asObservable();
  }
  setResetformSelectMultiple(info: DeleteInputSelect): void {
    this.resetformSelectMultiple.next(info);
  }
  getResetFilterSelectMultiple(): Observable<DeleteInputSelect> {
    return this.resetFilterSelectMultiple.asObservable();
  }
  setResetformInputSelect(info: DeleteInputSelect): void {
    this.resetformInput.next(info);
  }
  getResetformInputSelect(): Observable<DeleteInputSelect> {
    return this.resetformInput.asObservable();
  }
  setResetFilterSelectMultiple(info: DeleteInputSelect): void {
    this.resetFilterSelectMultiple.next(info);
  }
  getResetFilterInputSelect(): Observable<DeleteInputSelect> {
    return this.resetFilterInputSelect.asObservable();
  }
  setResetFilterInputSelect(info: DeleteInputSelect): void {
    this.resetFilterInputSelect.next(info);
  }
  getUpdateShoppingCart(): Observable<UpdateShoppingCartModel> {
    return this.updateShoppingCart.asObservable();
  }
  setUpdateShoppingCart(cart: UpdateShoppingCartModel): void {
    this.updateShoppingCart.next(cart);
  }
  setUpdateProfileInfo(): void {
    this.updateAdviserInfo.next();
  }
  getUpdateProfileInfo(): Observable<void> {
    return this.updateAdviserInfo.asObservable();
  }
  setNotificationToComponents(notification: boolean): void {
    this.notificationToComponents.next(notification);
  }
  getNotificationToComponents(): Observable<boolean> {
    return this.notificationToComponents.asObservable();
  }

  setItemsCodeToDelete(items: MissingItems[]): void {
    this.itemsToDelete.next(items);
  }
  getItemsCodeToDelete(): Observable<MissingItems[]> {
    return this.itemsToDelete.asObservable();
  }
  setTypeScreeView(typeScreenView: TypeScreenView): void {
    this.typeScreenView = typeScreenView;
    this.typeScreenViewObs.next(typeScreenView);
  }
  getTypeScreenView(): Observable<TypeScreenView> {
    return this.typeScreenViewObs.asObservable();
  }
  setRecipeSettingsAction(obj: RecipeSettingsObj): void {
    this.recipeSettingAction.next(obj);
  }
  getRecipeSettingsAction(): Observable<RecipeSettingsObj> {
    return this.recipeSettingAction.asObservable();
  }
  setProfileTabsSelected(tabSelected: TabsProfile): void {
    this.profileTabSelected.next(tabSelected);
  }

  restartSubject(): void {
    this.profileTabSelected = new BehaviorSubject<TabsProfile>(
      TabsProfile.default
    );
  }
  getProfileTabsSelected(): Observable<TabsProfile> {
    return this.profileTabSelected.asObservable();
  }
  setTabToReturn(tabToReturn: ReturnToTab): void {
    this.tabToReturn.next(tabToReturn);
  }
  getTabToReturn(): Observable<ReturnToTab> {
    return this.tabToReturn.asObservable();
  }
  setUpdateOnlyProfilePhoto(photo: FileSelectedResult): void {
    this.updateOnlyProfilePhoto.next(photo);
  }
  getUpdateOnlyProfilePhoto(): Observable<FileSelectedResult> {
    return this.updateOnlyProfilePhoto.asObservable();
  }
  setUpdateOnlyMenuProfilePhoto(photo: FileSelectedResult): void {
    this.updateOnlyMenuProfilePhoto.next(photo);
  }
  getUpdateOnlyMenuProfilePhoto(): Observable<FileSelectedResult> {
    return this.updateOnlyMenuProfilePhoto.asObservable();
  }
  setUpdateMenuPhoto(photoSelected: FileSelectedResult): void {
    this.updateMenuPhoto.next(photoSelected);
  }
  getUpdateMenuPhoto(): Observable<FileSelectedResult> {
    return this.updateMenuPhoto.asObservable();
  }
  setDefaultAddress(address: DirectionsAndTaxs): void {
    this.defaultAddress.next(address);
  }
  getDefaultAddress(): Observable<DirectionsAndTaxs> {
    return this.defaultAddress.asObservable();
  }
  setProfileWasScrolled(currentTabIndex: TabsProfile): void {
    this.myProfileViewWasScrolled.next(currentTabIndex);
  }
  getProfileWasScrolled(): Observable<TabsProfile> {
    return this.myProfileViewWasScrolled.asObservable();
  }
  setReloadData(object: ReloadData): void {
    this.realoadData.next(object);
  }
  getReloadData(): Observable<ReloadData> {
    return this.realoadData.asObservable();
  }
  setSignatureResult(signatureResult: SignatureData): void {
    this.signatureResult.next(signatureResult);
  }
  getSignatureResult(): Observable<SignatureData> {
    return this.signatureResult.asObservable();
  }
  setCardCodeOk(cardCOdeOk: boolean): void {
    this.isCardCodeOk.next(cardCOdeOk);
  }
  getIsCardCodeOk(): Observable<boolean> {
    return this.isCardCodeOk.asObservable().pipe(first());
  }

  setInfoIsLoading(): void {
    this.isInfoLoading.next();
  }

  getInfoIsLoading(): Observable<void> {
    return this.isInfoLoading.asObservable();
  }
  setActiveContainerSelector(
    activeContainer: ContainerSelectorEstructor
  ): void {
    this.activeContainerSelector.next(activeContainer);
  }
  getActiveContainerSelector(): Observable<ContainerSelectorEstructor> {
    return this.activeContainerSelector.asObservable();
  }
  setUpdateCouterPiecesShoppingCard(): void {
    this.couterPiecesShoppingCard.next();
  }
  getUpdateCouterPiecesShoppingCard(): Observable<void> {
    return this.couterPiecesShoppingCard.asObservable();
  }
  setWhoRequest(whoRequest: CallPlace): void {
    this.whoRequest.next(whoRequest);
  }
  getWhoRequest(): Observable<CallPlace> {
    return this.whoRequest.asObservable();
  }
  setInfoFavourites(infoFavourites: InfoFavourites): void {
    this.infoFavourites.next(infoFavourites);
  }
  getInfoFavourites(): Observable<InfoFavourites> {
    return this.infoFavourites.asObservable();
  }
  setWhoRequestMenu(whoRequest: MenuItem): void {
    this.whoRequestForMenu.next(whoRequest);
  }
  getWhoRequestMenu(): Observable<MenuItem> {
    return this.whoRequestForMenu.asObservable();
  }
  setResultNotificationGeneric(generalMessage: GeneralMessage): void {
    this.resultNotificationGeneric.next(generalMessage);
  }
  getResultGeneralNotification(): Observable<GeneralMessage> {
    return this.resultNotificationGeneric.asObservable();
  }
  setIsLoading(info: SpinnerConfig): void {
    this.isLoading.next(info);
  }
  getIsLoading(): Observable<SpinnerConfig> {
    return this.isLoading.asObservable();
  }
  getTotalProducts(): Observable<void> {
    return this.totalProducts.asObservable();
  }
  setTotalproducts(): void {
    this.totalProducts.next();
  }
  setDismissView(): void {
    this.dismissView.next();
  }
  getDismisView(): Observable<void> {
    return this.dismissView.asObservable();
  }
  setCatalogsMissingProduct(catalogs: ICatalogsMissingPro): void {
    this.catalogsMissingProduct.next(catalogs);
  }
  getCatalogsMissingProduct(): Observable<ICatalogsMissingPro> {
    return this.catalogsMissingProduct.asObservable();
  }
  setDeleteProduct(product: IProducts): void {
    this.deleteProduct.next(product);
  }
  getDeleteProduct(): Observable<IProducts> {
    return this.deleteProduct.asObservable();
  }
  setDeleteProductDetalleOrder(index: number): void {
    this.deleteProductById.next(index);
  }
  getDeleteProductDetalleOrder(): Observable<number> {
    return this.deleteProductById.asObservable();
  }
  setChangeDataDirectionUpdate(data: DeliveredDirections): void {
    this.dataDirectionUpdate.next(data);
  }
  getChangeDataDirectionUpdate(): Observable<DeliveredDirections> {
    return this.dataDirectionUpdate.asObservable();
  }
  setChangeDataPaymentUpdate(data: PaymentCard): void {
    this.dataPaymentUpdate.next(data);
  }
  getDownloadPrescription(): Observable<IOrders> {
    return this.downloadPrescription.asObservable();
  }
  setDownloadPrescription(data: IOrders): void {
    this.downloadPrescription.next(data);
  }
  getChangeDataPaymentUpdate(): Observable<PaymentCard> {
    return this.dataPaymentUpdate.asObservable();
  }
  setChangeDataDirectionDeliveryPayment(data: DeliveredDirections): void {
    this.dataDirectionDeliveryPayment.next(data);
  }
  getChangeDataDirectionDeliveryPayment(): Observable<DeliveredDirections> {
    return this.dataDirectionDeliveryPayment.asObservable();
  }
  setChangeTaxData(data: TaxData): void {
    this.taxData.next(data);
  }
  getChangeTaxData(): Observable<TaxData> {
    return this.taxData.asObservable();
  }
  setChangeTaxDataDeliveryPayment(data: TaxData): void {
    this.taxDataDeliveryPayment.next(data);
  }
  getChangeTaxDataDeliveryPayment(): Observable<TaxData> {
    return this.taxDataDeliveryPayment.asObservable();
  }
  setChangeFavorite(favorite: boolean): void {
    this.changeFavoriteEdit.next(favorite);
  }
  getChangeFavorite(): Observable<boolean> {
    return this.changeFavoriteEdit.asObservable();
  }
  setAutoSelectFirstTab(hasError: boolean): void {
    this.autoSelectFirstTab.next(hasError);
  }
  getAutoSelectFirstTab(): Observable<boolean> {
    return this.autoSelectFirstTab.asObservable();
  }
  setPaymentCardAction(estatus: boolean): void {
    this.paymentCardAction.next(estatus);
  }
  getPaymentCardAction(): Observable<boolean> {
    return this.paymentCardAction.asObservable();
  }
  setPaymentMethodsList(paymentMethods: PaymentCard[]): void {
    this.paymentMethodsList.next(paymentMethods);
  }
  getPaymentMethodsList(): Observable<PaymentCard[]> {
    return this.paymentMethodsList.asObservable();
  }
  setTitle(titles: string): void {
    this.title.next(titles);
  }
  getTitle(): Observable<string> {
    return this.title.asObservable();
  }
  setListTypeProduct(data: ListTypeProduct): void {
    this.typeProduct.next(data);
  }
  getListTypeProduct(): Observable<ListTypeProduct> {
    return this.typeProduct.asObservable();
  }
  setInfoClientAdviser(info: ClientDoctorModel): void {
    this.infoClientAdviser.next(info);
  }
  getInfoClientAdviser(): Observable<ClientDoctorModel> {
    return this.infoClientAdviser.asObservable();
  }
  setViewInfoClientAdviser(view: CheckShoppingAndAdviser): void {
    this.infoViewClientAdviser.next(view);
  }
  getViewInfoClientAdviser(): Observable<CheckShoppingAndAdviser> {
    return this.infoViewClientAdviser.asObservable();
  }
  updateClientDoctor(route: string): void {
    const options: RouteView[] = [
      {
        routes: [
          RoutesCons.shoppingCar,
          RoutesCons.deliveryData,
          RoutesCons.taxData,
          RoutesCons.orderResume,
          RoutesCons.generateOrderAdvisor,
          RoutesCons.confirmOrders,
          RoutesCons.editBuyOrder,
        ],
        view: {
          isHeaderClient: true,
          isShoppingCartShow: true,
        },
      },
      {
        routes: [RoutesCons.advisorUtilities, RoutesCons.orders, RoutesCons.invoicesPending],
        view: {
          isHeaderClient: true,
          isShoppingCartShow: false,
        },
      },
    ];
    const selected =
      options.find((option) => option.routes.includes(route)) ??
      new RouteView();
    this.setViewInfoClientAdviser(selected.view);
  }
  setValidateDoctorInfo(route: string): void {
    this.routeInfoDoctor.next(route);
  }
  getValidateDoctorInfo(): Observable<string> {
    return this.routeInfoDoctor.asObservable();
  }

  setOrderTabSelected(tab: TabsOrders): void {
    this.orderTabSelected.next(tab);
  }

  getOrderTabSelected(): Observable<TabsOrders> {
    return this.orderTabSelected.asObservable();
  }

  setSelectedItemCatalog(selectedItem: ItemInformation): void {
    this.selectedItemCatalog.next(selectedItem);
  }

  getSelectedItemCatalog(): Observable<ItemInformation> {
    return this.selectedItemCatalog.asObservable();
  }

  setShowAdvisorModal(show: boolean): void {
    this.showAdvisorsMobile.next(show);
  }
  getShowAdvisorModal(): Observable<boolean> {
    return this.showAdvisorsMobile.asObservable();
  }
  setValidateIfIsActive(params: ValidateParamsSearchForGroup): void {
    this.validateIfIsActive.next(params);
  }
  getValidateIfIsActive(): Observable<ValidateParamsSearchForGroup> {
    return this.validateIfIsActive.asObservable();
  }
  setResetBioquealClusters(params: boolean): void {
    this.isResetBioquealClusters.next(params);
  }
  getResetBioquealClusters(): Observable<boolean> {
    return this.isResetBioquealClusters.asObservable();
  }
  setAdvisorInfoOk(isOk: boolean): void {
    this.infoAdvisorIsOk.next(isOk);
  }
  getAdvisorInfoOk(): Observable<boolean> {
    return this.infoAdvisorIsOk.asObservable();
  }

  setInvoiceTab(tab: InvoiceTab): void {
    this.invoiceTab.next(tab);
  }

  getInvoiceTab(): Observable<InvoiceTab> {
    return this.invoiceTab.asObservable();
  }

  setScrollAverageTicket(): void {
    this.scrollAverageTicket.next();
  }

  getScrollAverageTicket(): Observable<void> {
    return this.scrollAverageTicket.asObservable();
  }

  getReloadPendingActiveOrdersCounter(): Observable<void> {
    return this.reloadCounter.asObservable();
  }

  setReloadPendingActiveOrdersCounter(): void {
    this.reloadCounter.next();
  }

  setReloadShoppingCar(typeShoppingCar: ReloadShoppingCar): void {
    this.reloadShoppingCar.next(typeShoppingCar);
  }
  getReloadShoppingCar(): Observable<ReloadShoppingCar> {
    return this.reloadShoppingCar.asObservable();
  }
  setShoppingCartNumber(data: CartCount[]): void {
    this.productsQuantity.next(data);
  }
  getShoppingCartNumber(): Observable<CartCount[]> {
    return this.productsQuantity.asObservable();
  }

  setChangeShoppingTab(data: ChangeShoppingTab): void {
    this.changeShoppingTab.next(data);
  }
  getChangeShoppingTab(): Observable<ChangeShoppingTab> {
    return this.changeShoppingTab.asObservable();
  }

  setClearSAPFilters(): void {
    this.clearSAPFilters.next();
  }
  getClearSAPFilters(): Observable<void> {
    return this.clearSAPFilters.asObservable();
  }

  setSelectedRange(data: SelectedDateRange): void {
    this.selectedPageFilter.next(data);
  }
  getSelectedRange(): Observable<SelectedDateRange> {
    return this.selectedPageFilter.asObservable();
  }

  setReloadDirection(type: DirectionsType): void {
    this.reloadDirectionByType.next(type);
  }
  getReloadDirection(): Observable<DirectionsType> {
    return this.reloadDirectionByType.asObservable();
  }

  getImageLoaded(): Observable<string> {
    return this.imageLoaded.asObservable();
  }
  setImageLoaded(url: string): void {
    this.imageLoaded.next(url);
  }
  getCouponCode(): Observable<string> {
    return this.couponCode.asObservable();
  }
  setCouponCode(coupon: string): void {
    this.couponCode.next(coupon);
  }
  setValidateFavorBalance(): void {
    this.validatefavorBalance.next();
  }
  getValidateFavorBalance(): Observable<void> {
    return this.validatefavorBalance.asObservable();
  }
  setStopFlow(): void {
    this.stopFlow.next();
  }
  getStopFlow(): Observable<void> {
    return this.stopFlow.asObservable();
  }
  setResetFilters(): void {
    this.resetFiltersSub.next();
  }
  getResetFilters(): Observable<void> {
    return this.resetFiltersSub.asObservable();
  }

  setGeneralSearch(search: string): void {
    this.generalSearch.next(search);
  }

  getGeneralSearch(): Observable<string> {
    return this.generalSearch.asObservable();
  }

  setPendingPromotions(pendingPromotions: number): void {
    this.pendingPromotions = pendingPromotions;
  }

  setAddressFilter(addressFilter: string): void {
    this.addressAliasFilter.next(addressFilter);
  }
  getAddressFilter(): Observable<string> {
    return this.addressAliasFilter.asObservable();
  }
}
